// extracted by mini-css-extract-plugin
export default {"RenderedDocumentsTable":"RenderedDocuments_RenderedDocumentsTable__4LyDk"};